import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState
} from 'react';
import {useApi} from './ApiProvider';
import * as Sentry from "@sentry/react";

const UserContext = createContext();

export default function UserProvider({children}) {
  const [user, setUser] = useState();
  const [actions, setActions] = useState([]);
  const [roles, setRoles] = useState([]);
  const [logoutPerformed, setLogoutPerformed] = useState(false);
  const api = useApi();

  useEffect(() => {
    (async () => {
      if (api.isAuthenticated()) {
        const response = await api.get('/users/me');
        if (response.ok) {
          setUser(response.body);
          Sentry.setUser({email: response.body.email});
          setActions(response.body.actions.map((action) => action.name));
          setRoles(response.body.roles.map((role) => role.name));
        } else {
          setUser(null);
          Sentry.setUser(null);
          setActions(null);
          setRoles(null);
        }
      } else {
        setUser(null);
        Sentry.setUser(null);
        setActions(null);
        setRoles(null);
      }
    })();
  }, [api]);

  const login = useCallback(async (username, password) => {
    let currentUser = null
    let currentUserRoles = null
    let currentUserActions = null
    const result = await api.login(username, password);
    if (result === 'ok') {
      const response = await api.get('/users/me');
      if (response.ok) {
        currentUser = response.body;
        setUser(currentUser);
        Sentry.setUser({email: response.body.email});
        currentUserActions = response.body.actions.map((action) => action.name)
        setActions(currentUserActions);
        currentUserRoles = response.body.roles.map((role) => role.name)
        setRoles(currentUserRoles);
      } else {
        setUser(currentUser);
        Sentry.setUser(null);
        setActions(currentUserActions);
        setRoles(currentUserRoles);
      }
    }
    return {
      status: result,
      user: currentUser,
      actions: currentUserActions,
      roles: currentUserRoles
    };
  }, [api]);

  const logout = useCallback(async () => {
    await api.logout();
    setUser(null);
    Sentry.setUser(null);
    setActions(null);
    setRoles(null);
    setLogoutPerformed(true);
  }, [api]);

  return (
    <UserContext.Provider
      value={{
        user,
        setUser,
        actions,
        setActions,
        roles,
        setRoles,
        login,
        logout,
        logoutPerformed
      }}>
      {children}
    </UserContext.Provider>
  );
}

export function useUser() {
  return useContext(UserContext);
}
